export const UUIDRegexStr =
  '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$';

/**
 * Make underscore cased strings user friendly (e.g. hello_world -> Hello World)
 *
 * @param {string} str - Underscore cased string
 * @returns {string} Title cased string
 */
export const underscoreToTitleCase = (str = '') => {
  if (!str || typeof str !== 'string') return '';
  
  const words = str.split('_');

  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const splitCapitalLetters = (str = '') => {
  if (!str || typeof str !== 'string') return '';
  
  const trimmed = str.trim();
  
  // Check if string has capital letters that should be split
  if (!(/[A-Z]/.test(trimmed) && /[a-z]/.test(trimmed))) {
    return trimmed; // Return as-is for all caps, all lowercase, or no letters
  }
  
  return trimmed
    .split(/(?=[A-Z])/)
    .join(' ')
    .replace(/\s+/g, ' ') // Replace multiple spaces with single space
    .trim();
};

export const nameValidation = (name = '') => {
  if (!name || typeof name !== 'string') return false;
  
  const trimmed = name.trim();
  return trimmed.length > 0 && trimmed.length <= 50;
};

export function truncateWithEllipsis(text, maxLength) {
  if (!text || typeof text !== 'string') {
    return '';
  }
  
  if (maxLength <= 0) {
    return '';
  }
  
  // Use Array.from to properly handle Unicode characters
  const chars = Array.from(text);
  
  if (chars.length <= maxLength) {
    return text;
  }
  
  if (maxLength === 3) {
    return '...';
  }
  
  if (maxLength < 3) {
    return '';
  }
  
  return chars.slice(0, maxLength - 3).join('') + '...';
}
